module.exports = __webpack_public_path__ + "img/20191206165025702.f88ffe2e.jpg";